import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import AdminEventHospitalityItem from "./AdminEventHospitalityItem";
import AdminDndList from "~/Admin/AdminDndList/AdminDndList";
import {Link} from "react-router-dom";

const AdminEventHospitality = ({match, event, onChange, ...props}) => {

    const [selectedId, setSelectedId] = useState(event.hospitalities[0]?.id || 0);

    const handleOrderChanged = (data) => {
        adminHttp.put('/events/' + event.id + '/hospitalities/order', {
            data: data.map(i => i.id)
        });
    }

    const handleAdd = () => {
        adminHttp.post('/events/' + event.id + '/hospitalities').then(res => {
            if (onChange) {
                onChange();
            }
        });
    }

    const selectedExp = event.hospitalities.find(item => item.id === selectedId);

    return (
        <div>
            <div className="card shadow-sm bg-white">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <h3>Trackside Hospitality</h3>
                        </div>
                        <div className="col-4">
                            <AdminDndList
                                key={event.updated_at}
                                onChanged={handleOrderChanged}
                                onSelect={setSelectedId}
                                selected={selectedId}
                                list={event.hospitalities} />

                                <button
                                    onClick={handleAdd}
                                    className="btn btn-primary btn-sm w-100">+ Add Hospitality</button>

                                <p className="mall mt-3">
                                    This list is determined by the packages created in the Itinerary Management section.
                                </p>

                                <p className="mall mt-3">
                                    <Link className="text-primary" to="/inventory/package">Create, edit or delete packages</Link>
                                </p>
                        </div>
                        <div className="col-8">
                            {selectedExp && <AdminEventHospitalityItem
                                key={selectedId}
                                onChange={onChange}
                                onDelete={onChange}
                                experience={selectedExp} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventHospitality);
